import { Button } from '~/components/ui/button';
import { Calendar } from '~/components/ui/improved-calendar';
import { Popover, PopoverContent, PopoverTrigger } from '~/components/ui/popover';
import { cn } from '~/lib/utils';
import { format } from 'date-fns';
import { enGB, nl } from 'date-fns/locale';
import { Calendar as CalendarIcon } from 'lucide-react';

interface DatePickerProps {
  date: Date | undefined;
  setDate: (date: Date | undefined) => void;
  placeholder?: string;
  className?: string;
  minDate?: Date;
  locale?: 'en' | 'nl';
}

export function DatePicker({ date, setDate, placeholder, className, minDate, locale }: DatePickerProps) {
  return (
    <Popover modal={true}>
      <PopoverTrigger className={className} asChild>
        <Button
          type="button"
          variant="outline"
          className={cn('flex w-full justify-start text-left font-normal', !date && 'text-muted-foreground')}
        >
          <CalendarIcon className="mr-2 size-4" />
          {date ? format(date, 'PPP') : <span>{placeholder}</span>}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0">
        <Calendar
          mode="single"
          fromDate={minDate}
          selected={date}
          onSelect={setDate}
          initialFocus
          captionLayout="dropdown"
          fromYear={1900}
          toYear={2100}
          defaultMonth={date || new Date()}
          locale={locale === 'nl' ? nl : enGB}
        />
      </PopoverContent>
    </Popover>
  );
}
